<template>
    <v-toolbar color="#2B3848" dark class="fixed-bar">
        <v-icon class="mr-4">{{ icon }}</v-icon>
        <v-toolbar-title class="mr-4 d-flex flex-column align-center">
            <template v-if="subtitle">
                <span class="d-flex">
                    <span class="font-weight-thin">{{ title }} |</span>
                    <span class="ml-1">{{ subtitle }}</span>
                </span>
            </template>
            <template v-else>
                <span class="font-weight-thin">{{ title }}</span>
            </template>
        </v-toolbar-title>

        <div class="px-8 d-flex flex-grow-1 align-center">
            <v-progress-linear indeterminate color="grey lighten-2" height="2"></v-progress-linear>
        </div>
    </v-toolbar>
</template>

<style lang="scss" scoped>
.fixed-bar {
    position: sticky !important;
    position: -webkit-sticky !important; /* for Safari */
    /* top: 64px !important; */
    top: 0px !important;
    width: 100% !important;
    z-index: 3 !important;
}
</style>

<script lang="ts">
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class extends Vue {
    @Prop({ default: "" })
    icon?: string;

    @Prop({ default: "Sin título" })
    title?: string;

    @Prop({ default: "" })
    subtitle?: string;
}
</script>
